import * as t from 'ts-schema';
export * from 'ts-schema';
export const partialObject = descriptorObj => {
  const keys = Object.keys(descriptorObj);
  return t.custom('optional object', (value, validateChild, __ctx) => {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) {
      return false;
    }
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const propertyValue = value[key];
      if (key in value && propertyValue !== undefined) {
        validateChild(descriptorObj[key], propertyValue, key);
      }
    }
    return true;
  });
};
export const nullable = schema => t.union(schema, t.literal(null));
export const and = t.intersection;